import { TitleCasePipe } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-btn-tab',
  standalone: true,
  imports: [TitleCasePipe],
  templateUrl: './btn-tab.component.html',
  styleUrl: './btn-tab.component.css',
})
export class BtnTabComponent {
  @Input() tabName: string = '';
  @Input() isActive: boolean = false;
  @Output() setTab = new EventEmitter<string>();

  onClick() {
    this.setTab.emit(this.tabName);
  }

  constructor() {}
}
